export default __webpack_public_path__ + "static/heels.en.cover-09322c8d467ed0dc252762e9479ee073.jpg";